import { createAction } from 'redux-actions'

import {
  fetchAvailableCertificates,
  fetchAvailableProperties,
  fetchOperationGroups,
  fetchTransporterInfo,
  fetchTransporterUserInfo,
} from '../screens/Settings/actions'
import { getLocalHostname } from '../utils/apiConstants'

import { loadLocalUser, saveUserPushToken } from './user'
import * as types from './types'


export const bootstrapLogged = () => (
  async (dispatch) => {
    await dispatch(loadLocalUser())
    await dispatch(saveUserPushToken())
    await dispatch(fetchTransporterInfo())
    await dispatch(fetchTransporterUserInfo())
    await dispatch(fetchAvailableProperties())
    await dispatch(fetchAvailableCertificates())
    dispatch(fetchOperationGroups())
  }
)

export const logout = () =>
  (dispatch, state) => {
    dispatch(createAction(types.USER_LOGOUT)())
    return state().application.keycloak.logout({
      redirectUri: getLocalHostname(),
    })
  }

export const networkLogout = () =>
  (dispatch, state) => {
    if (state().user) {
      dispatch(createAction(types.NETWORK_LOGOUT)())
      state().application.keycloak.logout({
        redirectUri: getLocalHostname(),
      })
    }
  }


export const clearReportProgress = () => dispatch => {
  dispatch(createAction(types.CLEAR_DOWNLOADED_REPORT)())
}
